import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import '@/components/ProjectFilesPopover/ProjectFilesPopover.css';
import { api, type ReaderFile } from '@/api/client';
import { EntityFilesPopoverServer } from '@/components/ProjectFilesPopover/EntityFilesPopoverServer';
import { getReaderFilesQueryOptions } from '@/components/ReaderFilesPopover/readerFilesPopoverQuery';

interface ReaderFilesPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  readerId: string;
  readerName: string;
  onClose: () => void;
}

/** Файлы чтеца в каталоге — тот же UI и поведение, что у ProjectFilesPopover. */
export function ReaderFilesPopover({ open, anchorEl, readerId, readerName, onClose }: ReaderFilesPopoverProps) {
  const queryClient = useQueryClient();
  const opts = getReaderFilesQueryOptions(readerId);

  const onMutationsSettled = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: ['readersTableSummaries'] });
  }, [queryClient]);

  return (
    <EntityFilesPopoverServer<ReaderFile>
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      entityTitle={readerName || 'Чтец'}
      filesQuery={{ queryKey: opts.queryKey, queryFn: opts.queryFn }}
      filesApi={{
        list: () => api.readerFiles.list(readerId),
        upload: (file, uploadedBy, onServerProgress, _fileType, _clientMetrics) =>
          api.readerFiles.upload(readerId, file, uploadedBy, onServerProgress),
        update: (fileId, data) => {
          if (data.file_name === undefined) {
            return Promise.reject(new Error('Поддерживается только переименование файла'));
          }
          return api.readerFiles.update(readerId, fileId, { file_name: data.file_name });
        },
        delete: (fileId) => api.readerFiles.delete(readerId, fileId),
      }}
      onMutationsSettled={onMutationsSettled}
    />
  );
}
